export default "__VITE_ASSET__BtHLhc03__"